import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

import type { IProModal } from "../../Modals/src/ProModal";
import { ProModal } from "../../Modals/src/ProModal";
import { useTranslation } from "../../WithTranslation/src/I18n";

import { Footer, ModalSubtitle, ModalTitle, TitleContainer } from "./SelectWorkspaceTrialModal";

const StyledModalSubtitle = styled(ModalSubtitle)`
    max-width: 70%;
`;

interface IAreYouSureModalProps {
    isOpen: boolean;
    onCloseClick: () => void;
    onConfirmationClick: () => void;
    title: string;
    subtitle: string;
}
const modalStyle = {
    customStyles: {
        content: {
            boxSizing: "content-box",
            width: "500px",
        },
    },
} satisfies IProModal;

export const AreYouSureModal = ({
    isOpen,
    onCloseClick,
    onConfirmationClick,
    subtitle,
    title,
}: IAreYouSureModalProps) => {
    const translate = useTranslation();

    return (
        <ProModal
            isOpen={isOpen}
            onCloseClick={onCloseClick}
            {...modalStyle}
        >
            <TitleContainer>
                <ModalTitle>{translate(title)}</ModalTitle>
            </TitleContainer>
            <StyledModalSubtitle>{translate(subtitle)}</StyledModalSubtitle>
            <Footer>
                <Button
                    onClick={onCloseClick}
                    type="flat"
                    label={"Cancel"}
                />
                <Button
                    onClick={onConfirmationClick}
                    type="primary"
                    label={"Yes"}
                />
            </Footer>
        </ProModal>
    );
};
